module.exports = __webpack_public_path__ + "img/2.9d7c17fe.webp";